import PropTypes from 'prop-types';
import React from 'react';

import t from '../../../labels/labelling-utils';
import { MatchStatusList, MatchStatusType } from '../../../typings/match';
import { MatchReportStatusList, ReportStatus } from '../../../typings/match-reports';
import { IReferee } from '../../../typings/player';
import { isPostponed } from '../../../utils/match-status';
import { isPublished } from '../../../utils/report-status';
import Callout from '../../atoms/callout/callout';
import ReportTabsPanel, { IReportTabsPanel } from '../../molecules/report-tabs-panel/report-tabs-panel';
import Team, { ITeam } from '../../molecules/team/team';
import TeamsTabs from '../../molecules/teams-tabs/teams-tabs';
import { IClassNames, makeClassNames } from '../../../utils/styles';

import './report-tabs.scss';

export interface IReportTeam extends ITeam {}

export interface IReportTabs extends IReportTabsPanel {
  away: IReportTeam;
  home: IReportTeam;
  idAway: string;
  idHome: string;
  referees?: Array<IReferee>;
  reportStatus?: ReportStatus;
  status?: MatchStatusType;
}

const classNames = (): IClassNames =>
  makeClassNames({
    reportTabs: 'report-tabs',
    panels: 'report-tabs__panels',
  });

const ReportTabs: React.FC<IReportTabs> = ({ away, home, idAway, idHome, referees, reportStatus, status }) => {
  const cn = classNames();

  let panel = null;
  if (reportStatus && isPublished(reportStatus)) {
    panel = <ReportTabsPanel home={home} away={away} referees={referees} status={status} />;
  } else if (isPostponed(status!)) {
    panel = <Callout>{t('report.tabs.postponed')}</Callout>;
  } else {
    panel = <Callout>{t('report.tabs.unavailable')}</Callout>;
  }

  return (
    <div className={cn.reportTabs}>
      <TeamsTabs idHome={idHome} idAway={idAway} home={home} away={away} />
      <div className={cn.panels} data-panels>
        {panel}
      </div>
    </div>
  );
};

/* istanbul ignore else */ if (process.env.NODE_ENV !== 'production') {
  ReportTabs.propTypes = {
    away: PropTypes.shape({ ...Team.propTypes! }).isRequired,
    home: PropTypes.shape({ ...Team.propTypes! }).isRequired,
    idAway: PropTypes.string.isRequired,
    idHome: PropTypes.string.isRequired,
    referees: PropTypes.arrayOf(
      PropTypes.shape({
        fullname: PropTypes.string,
        id: PropTypes.number.isRequired,
        name: PropTypes.string,
        surname: PropTypes.string,
      }).isRequired
    ),
    reportStatus: PropTypes.oneOf<ReportStatus>(MatchReportStatusList),
    status: PropTypes.oneOf<MatchStatusType>(MatchStatusList).isRequired,
  };
}

export default ReportTabs;
